<p-dialog
  [className]="'eccc'"
  [header]="'COMMON.labels.contactSupport' | translate"
  [closable]="false"
  [(visible)]="visible"
  [modal]="true"
  [style]="{width: '500px'}"
  [minY]="100"
  [maximizable]="false"
  [autoZIndex]="false">

  <h2 class="title"><span [innerHTML]="'COMMON.actionsLabel.contactMessage' + labelPrefix | translate"></span></h2>
  <!--<p>{{'COMMON.actionsLabel.contactMessagePhone' | translate}}<br>
    <span [innerHTML]="message"></span>
    </p>-->
  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <div class="float-right">
        <button id="CONTACT_SUPPORT_closeBtn" type="button" class="btn btn-secondary" (click)="close()">{{'COMMON.actionsLabel.CLOSE' | translate}}</button>
      </div>
    </div>
  </ng-template>

</p-dialog>
